import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import ListingPreview from '../../components/Proposal/Preview/Listing'
import WithProposalContainer from '../Common/WithProposalContainer'

ListingPreview.fetchData = async ({ store, req, res, match }) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const props = {
  proposalType: PROPOSAL_TYPE.NEW_LISTING
}

const MappedContainer = WithProposalContainer(ListingPreview, props)

export default MappedContainer
